import { Paper as MuiPaper, Grid, Typography } from "@mui/material";
import styled from "styled-components/macro";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image1 from "./assets/1.jpg";
import Image2 from "./assets/2.jpg";
import Image3 from "./assets/3.jpg";
import Image4 from "./assets/4.jpg";
import Image5 from "./assets/5.jpg";
import { Box } from "@mui/system";

const Paper = styled(MuiPaper)`
  background-color: #107de2;
  border-radius: 0px;
  text-align: center;
  color: #fff;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
`;

// Adjust the number of slides to show based on the screen width
const getSlidesToShow = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 600) {
    return 2; // Show 2 slides on small screens
  } else if (screenWidth < 960) {
    return 4; // Show 4 slides on medium screens
  } else {
    return 6; // Show 6 slides on larger screens
  }
};

const SliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: getSlidesToShow(), // Adjust the number of slides to show
};

const SliderContainer = styled("div")`
  margin: 0px 20px; /* Add margin from left and right sides */
  max-width: 100%; /* Ensure the slider doesn't exceed the screen width */
  overflow: hidden;
`;

const Slide = styled("div")`
  min-height: 90px;
  padding: 10px;
  margin: 10px;
`;

export default function Footer() {
  return (
    <Paper>
      <SliderContainer>
        <Slider {...SliderSettings}>
          <Slide>
            <img src={Image1} alt="Slide 1" width="100%" />
          </Slide>
          <Slide>
            <img src={Image2} alt="Slide 2" width="100%" />
          </Slide>
          <Slide>
            <img src={Image3} alt="Slide 3" width="100%" />
          </Slide>
          <Slide>
            <img src={Image4} alt="Slide 3" width="100%" />
          </Slide>
          <Slide>
            <img src={Image5} alt="Slide 4" width="100%" />
          </Slide>
          <Slide>
            <img src={Image1} alt="Slide 5" width="100%" />
          </Slide>
          <Slide>
            <img src={Image2} alt="Slide 6" width="100%" />
          </Slide>
          <Slide>
            <img src={Image3} alt="Slide 7" width="100%" />
          </Slide>
          {/* Add more slides as needed */}
        </Slider>
      </SliderContainer>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "20px",
          fontSize: "15px",
          fontFamily: "Open Sans, sans-serif",
          fontWeight: "400",
        }}
      >
        <Typography variant="body">
          Copyright © 2023. All Rights Reserved.
        </Typography>
        <Typography variant="body">Designed by MPSeDC CoE.</Typography>
      </Box>
    </Paper>
  );
}
